import { Colors } from '@/common/colors/colors';
import { getLastTicketNotification } from '../../../helpers/getLastTicketNotification';

export const getTicketBackgroundColor = (
	ticket,
	selectedTicket,
	currentUserId,
) => {
	if (selectedTicket?._id === ticket._id) {
		return Colors.newBlue;
	}

	if (ticket.type === 'correction') {
		return Colors.red;
	}

	const lastNotification = getLastTicketNotification(ticket);

	if (
		(lastNotification.sender || lastNotification.created_by) !==
			currentUserId &&
		!lastNotification.seen?.includes(currentUserId)
	) {
		return Colors.newLightGray;
	}

	return '#fff';
};
